import { render, staticRenderFns } from "./ModalBackofficeOPME.vue?vue&type=template&id=1bfc4ab5&scoped=true"
import script from "./ModalBackofficeOPME.vue?vue&type=script&lang=ts"
export * from "./ModalBackofficeOPME.vue?vue&type=script&lang=ts"
import style0 from "./ModalBackofficeOPME.vue?vue&type=style&index=0&id=1bfc4ab5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfc4ab5",
  null
  
)

export default component.exports